module.exports = __webpack_public_path__ + "static/media/marketing-digital-quito-aei.fe9002ff.jpg";